import React, { useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { useDispatch, useSelector } from "react-redux";

import CardSection from "../../../components/CardSection/CardSection";
import { setCuveData, clearCuve } from "./CuveSlice";
import { selectActiveUid } from "../../Auth/authSlice";
import {
  getKinshasaDateTime,
  getKinshasaDate,
} from "../../../utils/getKinshasaDateTime";
import { db } from "../../../config/firebaseConfig";

import { doc, setDoc } from "firebase/firestore";

const Cuve = () => {
  const myCuveStore = useSelector((state) => state.cuve);
  const listCuves = [
    { label: "C1", value: "C1" },
    { label: "C2", value: "C2" },
    { label: "C3", value: "C3" },
    { label: "C4", value: "C4" },
  ];

  const [selectedCuve, setSelectedCuve] = useState("");
  const [cuve, setCuve] = useState();
  const [cardOpen, setCardOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const activeUid = useSelector(selectActiveUid);

  const handleSelectedCuveChange = (event) => {
    setSelectedCuve(event.target.value);
    console.log("handleSelectedChange", event.target.value);
  };

  const handleChangeCuve = (event) => {
    setCuve(event.target.value);
    console.log("handleChangeIndex", event.target.value);
  };

  const handleAdd = () => {
    if (!selectedCuve || !cuve) return;

    const date = getKinshasaDateTime();
    dispatch(
      setCuveData({
        type: "CUVES",
        item: selectedCuve,
        value: cuve,
        date: date,
      }),
    );
    setSelectedCuve("");
    setCuve("");
    // Do not close here; close after Firestore write
  };

  const onClick = async (e) => {
    e.stopPropagation();
    setLoading(true);
    const date = getKinshasaDate();
    try {
      const docRef = doc(db, "users", activeUid, "data", date);
      await setDoc(docRef, { ...myCuveStore.cuve }, { merge: true });
      setCardOpen(false); // Close after Firestore write
      console.log("Document written with ID: ");
    } catch (e) {
      console.error("Error adding document: ", e);
    }
    dispatch(clearCuve());
    setLoading(false);
  };

  return loading ? (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginTop: 32,
      }}
    >
      <CircularProgress color="primary" size={48} />
      <div style={{ marginTop: 16, fontSize: 18 }}>Chargement...</div>
    </div>
  ) : (
    <CardSection
      title="CUVES"
      myStore={myCuveStore.cuve}
      listItem={listCuves}
      handleSelectedItemChange={handleSelectedCuveChange}
      selectedItem={selectedCuve}
      handleChangeValue={handleChangeCuve}
      handleAdd={handleAdd}
      selectedValue={cuve}
      onClick={onClick}
      open={cardOpen}
      setOpen={setCardOpen}
    />
  );
};

export default Cuve;
